export function isLaborCostTypeName(costTypeName: unknown): boolean {
  return String(costTypeName ?? '').toLowerCase() === 'labor';
}

export function itemMasterPhaseLabel(item: Record<string, unknown>): string {
  if (!isLaborCostTypeName(item.cost_type_name)) return '—';
  const value = item.phase_name;
  if (value == null || value === '') return '—';
  return String(value);
}

export function itemMasterSubPhaseLabel(item: Record<string, unknown>): string {
  if (!isLaborCostTypeName(item.cost_type_name)) return '—';
  const value = item.sub_phase_name;
  if (value == null || value === '') return '—';
  return String(value);
}
